import React, { useContext, useEffect, useState } from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import global from "../../../scss/dhp.scss";

import { Icon } from "../../ui/icon";
import { EditorContext } from "../../../containers/editor/EditorLayout";
import useCutWidget from "../../../hooks/useCutWidget";
import { EditorPanelContext } from "../../../containers/editor/EditorPanel";

let style = Object.assign({}, global);

const Cut = props => {
  let { rightContextMenu, updateRightContextMenu } = useContext(EditorContext);
  let { keyBoardEvent, updateKeyBoardEvent } = useContext(EditorPanelContext);

  const { cutWidget } = useCutWidget();

  const [isMac, setIsMac] = useState();

  const cutMethod = () => {
    updateKeyBoardEvent({ ...keyBoardEvent, cut: true });
    cutWidget();
    if (props.rightContext)
      updateRightContextMenu({
        ...rightContextMenu,
        enable: false,
      });
  };

  useEffect(() => {
    let isMacOS = /Mac/i.test(navigator.platform) || /Macintosh/i.test(navigator.userAgent);
    setIsMac(isMacOS);
  }, []);

  return (
    <li
      className={cx({
        [style["custom-tooltip"]]: !props.rightContext,
      })}>
      <span className={style["toolset-action"]} onClick={cutMethod}>
        <Icon icon="ui-scissors" />
        {props.rightContext && (
          <>
            Cut {isMac && <span>Cmd+X</span>}
            {!isMac && <span>Ctrl+X</span>}
          </>
        )}
      </span>
      {!props.rightContext && <div className={style["custom-tooltip-content"]}>Cut</div>}
    </li>
  );
};

Cut.propTypes = {
  rightContext: PropTypes.bool,
};

export default Cut;
